import queryString from "query-string";
import * as Yup from "yup";

import { trans } from "src/translations";
import { parseContainsQueryParam } from "utils/url";

const FilterValidator = Yup.string().test(
  "check-operators",
  trans.APP_MANIFESTS_SEARCH_SYNTAX_ERROR(),
  (value) => {
    // count operator '<' or '>' occurence
    const count3C = (value.match(/%3C/g) || []).length;
    const count3E = (value.match(/%3E/g) || []).length;
    return count3C <= 1 && count3E <= 1;
  }
);

export const schema = Yup.object().shape({
  contains: FilterValidator,
});

export const getSearchParams = (location) => queryString.parse(location.search);

const createSearchBarFilter = (filter) => ({
  id: filter.id,
  displayName: filter.display_name,
  param: filter.param,
  description: filter.description,
  hasSuggestions: ["oem", "client_type", "platform"].includes(
    filter.display_name
  ), // @todo: TAP-633-remove workaround
});

export const parseManifestFilters = (data = []) => ({
  sections: [
    {
      title: "Filters",
      options: data.map(createSearchBarFilter),
    },
  ],
});

export const retrieveFiltersFromSearchBar = (queryParams) => {
  const { contains, not_contains, sort_by, order, search, ...rest } =
    queryParams;
  let filters = rest;

  if (contains) {
    filters = {
      ...filters,
      ...parseContainsQueryParam(contains),
    };
  }

  if (search) {
    const appIds = Array.isArray(filters.provider_id)
      ? [...filters.provider_id, search]
      : filters.provider_id
        ? [filters.provider_id, search]
        : search;

    if (!filters.provider_id) {
      filters.provider_id_mode = "like";
    }

    filters.provider_id = appIds;
  }

  return filters;
};
